<template>
    <div class="json-reader">
        <h1 class="header-secure">Secure version</h1>
        <div class="changelog-content">
            <div v-for="entry in changelog" :key="entry.version">
                <h2 class="version_header">{{ entry.version }}</h2>
                <ul>
                    <li v-for="change in entry.changeLog" :key="change.changeDate">
                        <div class="change-date">{{ change.changeDate }}</div>
                        <div class="change-text">{{ change.changeText }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    import test from '../version/secureVersion.json';

    export default {
        data() {
            return {
                changelog: test,
            };
        },

    };
</script>

<style>
    .header-secure {
        text-decoration: underline;
        padding: 15px 15px 20px 15px;
    }

    .changelog-content {
        padding: 5px 15px 5px 15px;
    }

    .json-reader {
        background-color: white;
    }


    .version_header {
        font-size: 1rem;
        font-weight: 700;
    }
</style>